import React from 'react'

const Error = () => {
  return (
    <div className='flex  items-center justify-center my-auto  text-3xl text-white'>
       Page Not Found...
    </div>
  )
}

export default Error;
